import React from 'react';

export const ExpandableListComposer = (List) => class extends React.Component {

  render() {
    const {children, maxResultsOnCollapse = 5, maxResults = 99} = this.props;
    const collapsedList = children ? children.filter((c, i) => i < maxResultsOnCollapse) : [];
    const expandedList = children ? children.filter((c, i) => i >= maxResultsOnCollapse && i <= maxResults) : [];
    const toggleExpand = (e) => {
      if (this.props.toggleExpand) {
        this.props.toggleExpand(e);
      }
    };

    const additionalProps = {
      collapsedList,
      expandedList,
      toggleExpand
    };

    const props = Object.assign({}, this.props);
    const mergedProps = Object.assign(props, additionalProps);

    return <List {...mergedProps} />;
  }
};
